export const datas = [
    {
        label: 'สำนักงานบรรเทาทุกข์และประชานามัยพิทักษ์',
        url: 'http://www.rtrc.in.th'
    },
    {
        label: 'สำนักงานบริหารกิจการเหล่ากาชาด',
        url: 'https://chapternews.redcross.or.th'
    },
    {
        label: 'สำนักงานยุวกาชาดและอาสาสมัครกาชาด',
        url: 'https://trcyvolunteer.redcross.or.th'
    },
    {
        label: 'ศูนย์ฝึกอบรมปฐมพยาบาลและสุขภาพอนามัย',
        url: 'https://training.redcross.or.th'
    },
    {
        label: 'สำนักงานบริหารทรัพยากรบุคคล',
        url: 'https://hrtrcs.redcross.or.th'
    },
    {
        label: 'สำนักงานเทคโนโลยีสารสนเทศและดิจิทัล',
        url: 'https://it.redcross.or.th'
    },
    {
        label: 'กลุ่มงานสนับสนุนองค์กร',
        url: '#',
        children: [
            {
                label: 'สำนักงานบริหารกลาง',
                url: '#'
            },
            {
                label: 'สำนักงานบริหารระบบกายภาพ',
                url: 'https://oim.redcross.or.th'
            },
            {
                label: 'สำนักจัดซื้อ',
                url: '#'
            },
        ]
    },
    {
        label: 'สำนักงานจัดหารายได้',
        url: 'https://www.redcrossfundraising.org/th'
    },
    {
        label: 'สำนักงานจัดการทรัพย์สิน',
        url: 'https://property.redcross.or.th'
    },
    {
        label: 'สำนักกฎหมาย',
        url: 'https://redcross.or.th/aboutus/department/legal'
    },
    {
        label: 'สำนักงานการคลัง',
        url: 'https://finance.redcross.or.th/'
    },
    {
        label: 'กลุ่มงานกลยุทธ์องค์กร',
        url: 'https://redcross.or.th/aboutus/department/strategy',
        children: [
            {
                label: 'สำนักนโยบาย ยุทธศาสตร์ และงบประมาณ',
                url: '#'
            },
            {
                label: 'สำนักบริหารความเสี่ยงและควบคุมภายใน',
                url: '#'
            },
            {
                label: 'สำนักขับเคลื่อนการพัฒนา',
                url: '#'
            },
            {
                label: 'สำนักสารนิเทศและสื่อสารองค์กร',
                url: '#'
            },
        ]
    },
    {
        label: 'สำนักเลขาธิการ สภากาชาดไทย',
        url: '#',
        children: [
            {
                label: 'สำนักวิเทศสัมพันธ์',
                url: '#'
            }
        ]
    },
]

export const dataBlock1 = [
    {
        label: 'โรงพยาบาลจุฬาลงกรณ์',
        url: 'https://chulalongkornhospital.go.th'
    },
    {
        label: 'โรงพยาบาลสมเด็จพระบรมราชเทวี ณ ศรีราชา',
        url: 'https://somdej.or.th'
    },
    {
        label: 'ศูนย์เวชศาสตร์ฟื้นฟู',
        url: 'https://rehab.redcross.or.th'
    },
    {
        label: 'ศูนย์วิจัยโรคเอดส์',
        url: 'https://th.trcarc.org'
    }
]

export const dataBlock2 = [
    {
        label: 'ศูนย์บริการโลหิตแห่งชาติ',
        url: 'https://blooddonationthai.com'
    },
    {
        label: 'สถานเสาวภา',
        url: 'https://saovabha.org'
    },
    {
        label: 'ศูนย์ดวงตาสภากาชาดไทย',
        url: 'https://eyebankthai.redcross.or.th'
    },
    {
        label: 'ศูนย์รับบริจาคอวัยวะสภากาชาดไทย',
        url: 'https://www.organdonate.in.th'
    }
]

export const dataBlock3 = [
    {
        label: 'สำนักงานตรวจสอบสภากาชาดไทย',
        url: 'https://audit.redcross.or.th'
    },
    {
        label: 'มูลนิธิสงเคราะห์เด็กสภากาชาดไทย',
        url: 'https://trcch.redcross.or.th'
    },
    {
        label: 'สถาบันการพยาบาลศรีสวรินทิรา สภากาชาดไทย',
        url: 'https://stin.ac.th/th/'
    }
]
export const dataAddress = {
    address: 'สภากาชาดไทย เลขที่ 1871 ถนนพระรามที่ 4',
    district: 'เขตปทุมวัน',
    subDistrict: 'แขวงปทุมวัน',
    postCode: '10330',
    province: 'กรุงเทพฯ',
    newAddress: [
        'สำนักงานบริหารทรัพยากรบุคคล สภากาชาดไทย',
        '1871 ถนนพระรามที่ 4 เขตปทุมวัน กรุงเทพฯ 10330',
        'งานสรรหาบุคลากร',
        '022564055 กด 1',
        'ฝ่ายบริหารทรัพยากรบุคคลกลุ่มภารกิจ',
        '022564055 กด 6'
    ],
    telephone: '02 256 4059, 02 251 8524',
    telephone2: 'หรือ 02 256 4000 ต่อ 3297-3299',
    email: 'job.trcs@redcross.or.th',
    facebook: 'https://www.facebook.com/ThaiRedCrossSociety/',
    ig: 'https://www.instagram.com/thairedcross/',
    twitter: 'https://twitter.com/ThaiRedCross',
}